module.exports = __webpack_public_path__ + "static/media/icon-character__bertolt-brecht.9655b3fb.svg";